module.exports = __webpack_public_path__ + "media/t_bpair.7b932b08.mp3";